import { ProgressSpinner } from 'primereact/progressspinner'

const Loading = () => {
  return (
    <div
      style={{
        width: '100%',
        minHeight: '100vh',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <ProgressSpinner
        style={{ width: '50px', height: '50px' }}
        strokeWidth="8"
        animationDuration=".5s"
      />
    </div>
  )
}

export default Loading
